<template>
  <div class="p-1">
    <div v-if="showError" class="w-100 text-center pt-4">
      <h2 class="mb-1">Page Not Found 🕵🏻‍♀️</h2>
      <p class="mb-2">
        Oops! 😖 The requested URL was not found on this server.
      </p>
      <b-img fluid :src="imgUrl" alt="Error page" />
    </div>
    <b-row v-else class="match-height" align-h="center">
      <b-col md="7">
        <!-- <b-card v-if="showMessage">
          <b-row align-h="center">
            <b-col class="text-center">
              <b-img
                ref="previewEl"
                src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                style="border-radius: 100px"
                fluid
                height="100px"
                width="100px"
              />
              <div class="mt-1">
                <h5>School Name</h5>
                <h5>School Email</h5>
                <h5>School Contact</h5>
              </div>
            </b-col>
          </b-row>

          <b-row align-h="center" class="mt-1">
            <b-col class="text-center">
              <feather-icon
                icon="CheckCircleIcon"
                size="65"
                class="text-success mb-1"
              />
              <h4>Application Submiited</h4>
              <h4>Thank You for Registration!</h4>
              <h4>We will review your request</h4>
            </b-col>
          </b-row>
        </b-card> -->
        <b-row align-h="center" class="mb-1">
          <b-col class="text-center" md="12">
            <b-img
              v-if="school.logo == null || school.logo == ''"
              ref="previewEl"
              src="https://cdn.cloudious.net/file-1776666463641-10693955.png"
              style="object-fit: contain"
              fluid
              height="100px"
              width="100px"
            />
            <b-img
              v-else
              ref="previewEl"
              :src="school.logo"
              style="object-fit: contain"
              fluid
              height="100px"
              width="100px"
            />
            <div class="mt-1">
              <h3>{{ school.name }}</h3>
              <h5>
                <feather-icon icon="MapPinIcon" class="mr-50" />
                {{ school.address }}
              </h5>
              <h5>
                <feather-icon icon="PhoneIcon" class="mr-50" />
                {{ school.phone || school.mobile }}
              </h5>
            </div>
          </b-col>
        </b-row>
        <b-card class="">
          <h4 class="text-uppercase mb-0">Staff Registration</h4>
          <hr />
          <h5 v-if="isMyskoolIuss" class="text-primary font-weight-bold mb-1">
            Employee Details
            <feather-icon
              icon="HelpCircleIcon"
              size="16"
              class="ml-25 text-muted"
              v-b-tooltip.hover
              title="General applicant information — name, contact, address, etc."
            />
          </h5>
          <!-- <b-row align-h="center">
            <b-col class="text-center">
              <b-img
                ref="previewEl"
                src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                style="border-radius: 100px"
                fluid
                height="100px"
                width="100px"
              />
              <div class="mt-1">
                <h3>Lorem ipsum</h3>
                <h5>
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Mollitia necessitatibutur iste aperia suscipit.
                </h5>
                <h5>0322 6482902</h5>
              </div>
            </b-col>
          </b-row>
          <hr /> -->
          <b-row align-h="center">
            <!-- <b-col md="12">
              <h4 class="text-center mt-1">Application Form</h4>
            </b-col> -->
            <b-col class="ml-3" cols="3">
              <b-form-group
                class="text-center"
                ref="picture"
                :state="nameState"
                label=" "
                label-for="name-input"
                invalid-feedback="Picture is required."
              >
                <b-media no-body ref="picture">
                  <b-media-aside class="staff-photo-aside">
                    <div class="staff-photo-upload">
                      <div
                        v-if="!profilePicturePreview && logoloading !== true"
                        class="staff-photo-frame"
                      >
                        <b-link @click="$refs.fileProfile.click()">
                          <b-img
                            ref="previewEl"
                            src="https://cdn.cloudious.net/file-1677912450367-333289208.png"
                            style="border-radius: 100px"
                            fluid
                            height="120px"
                            width="120px"
                          />
                        </b-link>
                      </div>

                      <div
                        v-else-if="!profilePicturePreview && logoloading === true"
                        class="staff-photo-frame"
                      >
                        <b-spinner
                          variant="primary"
                          type="grow"
                          label="Spinning"
                        />
                      </div>

                      <div
                        v-else
                        class="staff-photo-frame staff-photo-frame--loaded"
                      >
                        <img
                          class="rcorners2 staff-photo-img"
                          :src="profilePicturePreview"
                          alt="Profile photo"
                          referrerpolicy="no-referrer"
                          @error="onProfilePreviewError"
                          @click="
                            logoloading !== true && $refs.fileProfile.click()
                          "
                        />
                        <div
                          v-if="logoloading === true"
                          class="staff-photo-upload-overlay"
                        >
                          <b-spinner variant="primary" type="grow" />
                        </div>
                        <b-button
                          v-if="logoloading !== true"
                          class="staff-photo-delete-btn"
                          variant="danger"
                          @click.stop="deleteLogo()"
                        >
                          <feather-icon icon="Trash2Icon" size="16" />
                        </b-button>
                      </div>

                      <input
                        type="file"
                        id="fileProfile"
                        hidden
                        ref="fileProfile"
                        @change="selectlogo()"
                        accept="image/*"
                      />
                    </div>
                  </b-media-aside>
                </b-media>
                <small class="mr-1 text-danger" v-if="logoerror"
                  >Logo is required.</small
                >
              </b-form-group>
            </b-col>
            <!-- <b-col cols="4"> </b-col> -->
          </b-row>
          <!-- <h3 class="mt-1">Student Information</h3> -->

          <b-row>
            <b-col md="6">
              <b-form-group
                label="Name *"
                invalid-feedback="Name is required"
                label-class="font-weight-bold"
              >
                <b-form-input
                  placeholder="Enter name"
                  ref="name"
                  v-model.trim="myObj.staff.name"
                  @focusout="CheckName()"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label="Father name *"
                invalid-feedback="Father name is required"
                label-class="font-weight-bold"
              >
                <b-form-input
                  ref="fname"
                  placeholder="Enter father name"
                  v-model.trim="myObj.staff.father_name"
                  @focusout="CheckFName()"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Gender *"
                invalid-feedback="School name is required."
                label-class="font-weight-bold"
                ref="gender"
              >
                <v-select
                  v-model="myObj.staff.gender"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="genders"
                  :clearable="false"
                  placeholder="Select gender"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Date of Birth *"
                invalid-feedback="Date of Birth is required."
                label-class="font-weight-bold"
                ref="dob"
              >
                <flat-pickr
                  :config="config"
                  v-model="myObj.staff.date_of_birth"
                  class="form-control"
                  placeholder="Select date of birth"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Contact *"
                invalid-feedback="Contact number is required"
                label-class="font-weight-bold"
              >
                <vue-tel-input
                  v-model="myObj.staff.contact_number"
                  :inputOptions="vueTelOptions"
                  :dropdownOptions="dropOptions"
                  :defaultCountry="$store.state.countryCode"
                  @input="CheckSContact"
                ></vue-tel-input>
                <small class="mr-1 text-danger" v-if="sPhoneerror"
                  >Contact number is required</small
                >
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="!isMyskoolIuss">
              <b-form-group
                label="Qualification *"
                invalid-feedback="qualification is required."
                label-class="font-weight-bold"
              >
                <b-form-input
                  ref="qua"
                  placeholder="Enter qualification."
                  v-model.trim="myObj.staff.qualification"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Designation *"
                invalid-feedback="designation is required."
                label-class="font-weight-bold"
                ref="design"
              >
                <v-select
                  v-if="showDesignationField"
                  v-model="myObj.staff.designation"
                  :options="designationOptions"
                  :reduce="(opt) => opt.name"
                  label="name"
                  :clearable="false"
                  :disabled="dataloading || !myObj.staff.departmentID"
                  placeholder="Select designation"
                  @input="CheckDesignation()"
                />
                <b-form-input
                  v-else
                  placeholder="Enter designation"
                  v-model.trim="myObj.staff.designation"
                  @focusout="CheckDesignation()"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Experience"
                invalid-feedback="Experience is required."
              >
                <b-form-input
                  placeholder="Enter experience"
                  v-model.trim="myObj.staff.experience"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="!isMyskoolIuss">
              <b-form-group label="Stream" label-class="font-weight-bold">
                <v-select
                  v-model="myObj.staff.streamID"
                  :options="streamOptions"
                  :reduce="(opt) => opt.id"
                  label="name"
                  :clearable="true"
                  placeholder="Select stream"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="showCampusField">
              <b-form-group
                invalid-feedback="Campus is required."
                label-class="font-weight-bold"
                ref="camp"
              >
                <template #label>
                  <span class="d-inline-flex align-items-center font-weight-bold">
                    Campus *
                    <feather-icon
                      icon="HelpCircleIcon"
                      size="14"
                      class="ml-25 text-muted"
                      v-b-tooltip.hover
                      title="Select the campus you are applying to."
                    />
                  </span>
                </template>
                <v-select
                  v-model="myObj.staff.campusID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="campuses"
                  :clearable="false"
                  :reduce="(val) => val.id"
                  label="branch"
                  placeholder="Select campus"
                  @input="setData()"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                invalid-feedback="Department is required."
                label-class="font-weight-bold"
                ref="dep"
              >
                <template #label>
                  <span class="d-inline-flex align-items-center font-weight-bold">
                    Department *
                    <feather-icon
                      icon="HelpCircleIcon"
                      size="14"
                      class="ml-25 text-muted"
                      v-b-tooltip.hover
                      title="Department where staff is needed. Pre-filled and locked when opened via a department-specific shared link."
                    />
                  </span>
                </template>
                <v-select
                  v-model="myObj.staff.departmentID"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="departments"
                  :clearable="false"
                  :reduce="(val) => val.id"
                  label="name"
                  :disabled="depLoading || departmentLockedFromUrl"
                  placeholder="Select department"
                  @input="onDepartmentChange()"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="isMyskoolIuss">
            <b-row class="iuss-entry-section">
              <b-col md="12">
                <div class="d-flex align-items-center justify-content-between mb-50">
                  <h5 class="mb-0 font-weight-bold">
                    Qualifications *
                    <feather-icon
                      icon="HelpCircleIcon"
                      size="14"
                      class="ml-25 text-muted"
                      v-b-tooltip.hover
                      title="Add each degree or qualification separately."
                    />
                  </h5>
                  <b-button
                    variant="primary"
                    class="btn-icon rounded-circle iuss-entry-add-btn"
                    v-b-tooltip.hover
                    title="Add qualification"
                    @click="addQualification()"
                  >
                    <feather-icon icon="PlusIcon" size="18" />
                  </b-button>
                </div>

                <b-row class="iuss-entry-head d-none d-md-flex text-muted small font-weight-bold mb-25 mx-0">
                  <b-col md="3" class="px-50">Degree *</b-col>
                  <b-col md="2" class="px-50">Subject</b-col>
                  <b-col md="2" class="px-50">Institute</b-col>
                  <b-col md="2" class="px-50">Year</b-col>
                  <b-col md="2" class="px-50">Grade</b-col>
                  <b-col md="1" class="px-50"></b-col>
                </b-row>

                <div
                  v-for="(qual, qIndex) in qualifications"
                  :key="'qual-' + qIndex"
                  class="iuss-entry-row"
                >
                  <b-row class="iuss-entry-row-inner mx-0">
                    <b-col cols="12" md="3" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Degree *"
                        label-class="font-weight-bold d-md-none mb-50"
                        :invalid-feedback="
                          qIndex === 0 ? 'Qualification is required.' : ''
                        "
                        :ref="qIndex === 0 ? 'qua' : undefined"
                      >
                        <div class="iuss-entry-select-wrap">
                          <v-select
                            v-model="qual.degree"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="qualificationOptions"
                            :clearable="false"
                            :disabled="dataloading"
                            placeholder="Select degree"
                            @input="CheckQualification()"
                          />
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="2" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Subject"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter subject"
                          v-model.trim="qual.subject"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="2" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Institute"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter institute"
                          v-model.trim="qual.institute"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col :cols="qualifications.length > 1 ? 5 : 6" md="2" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Year"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter year"
                          v-model.trim="qual.year"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col :cols="qualifications.length > 1 ? 5 : 6" md="2" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Grade"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter grade"
                          v-model.trim="qual.grade"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="2"
                      md="1"
                      class="px-50 iuss-entry-actions"
                      v-if="qualifications.length > 1"
                    >
                      <b-button
                        variant="outline-danger"
                        class="btn-icon rounded-circle iuss-entry-remove-btn"
                        v-b-tooltip.hover
                        title="Remove qualification"
                        @click="removeQualification(qIndex)"
                      >
                        <feather-icon icon="Trash2Icon" size="16" />
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>

            <b-row class="iuss-entry-section mt-1">
              <b-col md="12">
                <div class="d-flex align-items-center justify-content-between mb-50">
                  <h5 class="mb-0 font-weight-bold">
                    Certificates
                    <feather-icon
                      icon="HelpCircleIcon"
                      size="14"
                      class="ml-25 text-muted"
                      v-b-tooltip.hover
                      title="Optional — add professional or training certificates."
                    />
                  </h5>
                  <b-button
                    variant="primary"
                    class="btn-icon rounded-circle iuss-entry-add-btn"
                    v-b-tooltip.hover
                    title="Add certificate"
                    @click="addCertificate()"
                  >
                    <feather-icon icon="PlusIcon" size="18" />
                  </b-button>
                </div>

                <b-row
                  v-if="certificates.length"
                  class="iuss-entry-head d-none d-md-flex text-muted small font-weight-bold mb-25 mx-0"
                >
                  <b-col md="4" class="px-50">Certificate</b-col>
                  <b-col md="4" class="px-50">Institute</b-col>
                  <b-col md="2" class="px-50">Year</b-col>
                  <b-col md="2" class="px-50"></b-col>
                </b-row>

                <div
                  v-for="(cert, cIndex) in certificates"
                  :key="'cert-' + cIndex"
                  class="iuss-entry-row"
                >
                  <b-row class="iuss-entry-row-inner mx-0">
                    <b-col cols="12" md="4" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Certificate"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter certificate name"
                          v-model.trim="cert.name"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="4" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Institute"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter institute"
                          v-model.trim="cert.institute"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="10" md="2" class="px-50">
                      <b-form-group
                        class="iuss-entry-field"
                        label="Year"
                        label-class="font-weight-bold d-md-none mb-50"
                      >
                        <b-form-input
                          placeholder="Enter year"
                          v-model.trim="cert.year"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="2" md="2" class="px-50 iuss-entry-actions">
                      <b-button
                        variant="outline-danger"
                        class="btn-icon rounded-circle iuss-entry-remove-btn"
                        v-b-tooltip.hover
                        title="Remove certificate"
                        @click="removeCertificate(cIndex)"
                      >
                        <feather-icon icon="Trash2Icon" size="16" />
                      </b-button>
                    </b-col>
                  </b-row>
                </div>

                <p
                  v-if="!certificates.length"
                  class="text-muted small mb-0"
                >
                  No certificates added yet.
                </p>
              </b-col>
            </b-row>
          </template>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Teaching Level"
                invalid-feedback="Teaching Level is required."
              >
                <v-select
                  v-if="isMyskoolIuss"
                  v-model="myObj.staff.teachingLevel"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="iussTeachingLevelOptions"
                  :clearable="true"
                  placeholder="Select teaching level"
                />
                <b-form-input
                  v-else
                  placeholder="Enter teaching level"
                  v-model.trim="myObj.staff.teachingLevel"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="CNIC *"
                invalid-feedback="CNIC is required."
                label-class="font-weight-bold"
                ref="cnic"
              >
                <b-form-input
                  placeholder="Enter CNIC"
                  v-model.trim="myObj.staff.cnic"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Applied on"
                invalid-feedback="Applied on is required."
              >
                <flat-pickr
                  :config="config"
                  v-model="myObj.staff.registrationDate"
                  class="form-control"
                  :placeholder="$t('Select Date')"
                  disabled
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Current Address *"
                invalid-feedback="Contact number is required"
                label-class="font-weight-bold"
                ref="address"
              >
                <b-form-input
                  placeholder="Enter current address"
                  v-model.trim="myObj.staff.address_current"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Permanent Address"
                invalid-feedback="Contact number is required"
              >
                <b-form-input
                  placeholder="Enter permanent address"
                  v-model.trim="myObj.staff.address_permanent"
                />
              </b-form-group>
            </b-col>
            <template v-if="isMyskoolOrIuss">
              <b-col md="6">
                <b-form-group label="Province" label-class="font-weight-bold">
                  <v-select
                    v-model="myObj.staff.province"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pakistanProvinces"
                    :clearable="true"
                    placeholder="Select province"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="City" label-class="font-weight-bold">
                  <b-form-input
                    v-model.trim="myObj.staff.city"
                    placeholder="Enter city"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="LinkedIn Profile"
                  label-class="font-weight-bold"
                >
                  <b-form-input
                    v-model.trim="myObj.staff.linkedinProfile"
                    placeholder="https://linkedin.com/in/username"
                  />
                </b-form-group>
              </b-col>
            </template>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                label="Teaching Subjects"
                invalid-feedback="Subjects are required."
                ref="sub"
              >
                <v-select
                  v-model="myObj.subjectIDs"
                  multiple
                  :closeOnSelect="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="subjects"
                  :reduce="(opt) => opt.id"
                  label="subject"
                  :clearable="false"
                  :disabled="dataloading"
                  placeholder="Select teaching subjects"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                :invalid-feedback="isMyskoolIuss ? 'Availability is required.' : 'Availability is required.'"
                label-class="font-weight-bold"
                ref="avail"
              >
                <template #label>
                  <span class="d-inline-flex align-items-center font-weight-bold">
                    Availability<span v-if="isMyskoolIuss"> *</span>
                    <feather-icon
                      icon="HelpCircleIcon"
                      size="14"
                      class="ml-25 text-muted"
                      v-b-tooltip.hover
                      :title="isMyskoolIuss
                        ? 'Indicate when you can join — immediately or within a few days.'
                        : 'Your employment availability type.'"
                    />
                  </span>
                </template>
                <v-select
                  v-model="myObj.staff.availibility"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="isMyskoolIuss ? iussAvailabilityOptions : availibility"
                  :clearable="false"
                  input-id="categoryId"
                  placeholder="Select availability"
                  @input="CheckAvailability()"
                />
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="isMyskoolOrIuss">
              <b-form-group
                invalid-feedback="Last salary drawn is required."
                label-class="font-weight-bold"
                ref="prevSalary"
              >
                <template #label>
                  <span class="d-inline-flex align-items-center font-weight-bold">
                    Last Salary Drawn<span v-if="isMyskoolIuss"> *</span>
                    <feather-icon
                      icon="HelpCircleIcon"
                      size="14"
                      class="ml-25 text-muted"
                      v-b-tooltip.hover
                      title="Enter your previous / last drawn salary amount."
                    />
                  </span>
                </template>
                <b-form-input
                  type="number"
                  v-model="myObj.staff.previousSalary"
                  class="form-control"
                  placeholder="Enter last salary drawn"
                  @focusout="CheckPreviousSalary()"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Expected Salary *"
                invalid-feedback="Expected salary is required."
                label-class="font-weight-bold"
              >
                <b-form-input
                  ref="salary"
                  type="number"
                  v-model="myObj.staff.expectedSalary"
                  class="form-control"
                  placeholder="Enter expected salary"
                />
              </b-form-group>
            </b-col>
            <template v-if="isMyskoolOrIuss">
              <b-col md="6" class="mt-1">
                <b-form-group
                  label="Upload Salary Slip"
                  label-class="font-weight-bold"
                >
                  <b-button
                    variant="outline-primary"
                    block
                    :disabled="salarySlipLoading"
                    @click="$refs.salarySlipInput.click()"
                  >
                    <b-spinner
                      v-if="salarySlipLoading"
                      type="grow"
                      small
                      label="Loading..."
                    />
                    <span v-else>
                      {{
                        myObj.staff.salarySlip
                          ? "Replace Salary Slip"
                          : "Upload Salary Slip"
                      }}
                    </span>
                  </b-button>
                  <input
                    ref="salarySlipInput"
                    type="file"
                    hidden
                    accept="image/*,.pdf"
                    :disabled="salarySlipLoading"
                    @change="uploadSalarySlip()"
                  />
                  <div
                    v-if="myObj.staff.salarySlip"
                    class="d-flex align-items-center mt-50"
                  >
                    <a
                      :href="getDocOpenUrl(myObj.staff.salarySlip)"
                      target="_blank"
                      class="d-flex align-items-center mr-1"
                    >
                      <div class="file-type">
                        {{ getDocumentTypeLabel(myObj.staff.salarySlip) }}
                      </div>
                      <span class="ml-50 text-primary">View salary slip</span>
                    </a>
                    <feather-icon
                      icon="Trash2Icon"
                      size="18"
                      class="text-danger cursor-pointer"
                      @click="removeSalarySlip()"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col md="6" class="mt-1">
                <b-form-group label="Upload CV" label-class="font-weight-bold">
                  <b-button
                    variant="outline-primary"
                    block
                    :disabled="cvLoading"
                    @click="$refs.cvFileInput.click()"
                  >
                    <b-spinner
                      v-if="cvLoading"
                      type="grow"
                      small
                      label="Loading..."
                    />
                    <span v-else>
                      {{ myObj.staff.cv ? "Replace CV" : "Upload CV" }}
                    </span>
                  </b-button>
                  <input
                    ref="cvFileInput"
                    type="file"
                    hidden
                    accept="image/*,.pdf,.doc,.docx"
                    :disabled="cvLoading"
                    @change="uploadStaffCv()"
                  />
                  <div
                    v-if="myObj.staff.cv"
                    class="d-flex align-items-center mt-50"
                  >
                    <a
                      :href="getDocOpenUrl(myObj.staff.cv)"
                      target="_blank"
                      class="d-flex align-items-center mr-1"
                    >
                      <div class="file-type">
                        {{ getDocumentTypeLabel(myObj.staff.cv) }}
                      </div>
                      <span class="ml-50 text-primary">View CV</span>
                    </a>
                    <feather-icon
                      icon="Trash2Icon"
                      size="18"
                      class="text-danger cursor-pointer"
                      @click="removeStaffCv()"
                    />
                  </div>
                </b-form-group>
              </b-col>
            </template>
            <b-col md="12" class="mt-2">
              <div class="file-uploader">
                <h5>
                  <b-spinner
                    variant="dark"
                    label="Spinning"
                    v-if="uploading"
                  ></b-spinner>
                  <span v-else> Upload Documents </span>
                </h5>
                <input
                  ref="cvDoc"
                  type="file"
                  class="file_upload"
                  @change="uploadDocument()"
                  multiple="true"
                />
              </div>
            </b-col>
            <b-col md="12" class="mt-1">
              <div
                v-for="(file, index) in documents"
                :key="'staff-doc-' + index"
                class="file"
              >
                  <a
                    :href="getDocOpenUrl(file)"
                    target="_blank"
                    style="display: flex; align-items: center; min-width: 0; flex: 1"
                  >
                    <img
                      v-if="isImageDoc(file)"
                      :src="getDocPreviewUrl(file)"
                      class="doc-list-thumb"
                      alt="Document preview"
                      referrerpolicy="no-referrer"
                      @error="onDocPreviewError($event, file)"
                    />
                    <div v-else class="file-type">
                      {{ getDocumentTypeLabel(file) }}
                    </div>
                    <p class="file-name" :title="getDocumentDisplayName(file, index)">
                      {{ getDocumentDisplayName(file, index) }}
                    </p>
                  </a>
                  <div class="file-delete">
                    <i
                      class="fa fa-trash"
                      aria-hidden="true"
                      @click="deleteDocument(index)"
                    ></i>
                  </div>
                </div>
            </b-col>
          </b-row>
        </b-card>
        <b-button
          @click="formSubmitted()"
          variant="success"
          :disabled="request || uploading"
          block
        >
          <b-spinner v-if="request" type="grow" small label="Loading..." />
          <span v-else>Submit</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Ripple from "vue-ripple-directive";
import { VBTooltip } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import {
  getUploadPath,
  getUploadedPaths,
  uploadToMySkool,
  getMediaPreviewUrl,
  handleDrivePreviewError,
  getDocumentTypeLabel,
  getDocumentDisplayName,
  isImageUrl,
} from "@/utils/gdriveUpload";
import {
  buildStreamOptions,
  normalizeStreamIdForUi,
  streamIdForApi,
} from "@/views/myskool/staff/streamUtils";
import vue2Dropzone from "vue2-dropzone";

import "vue2-dropzone/dist/vue2Dropzone.min.css";

const DEFAULT_QUALIFICATION_OPTIONS = [
  "Under Matric",
  "Matric",
  "Intermediate",
  "Bachelors",
  "Masters",
  "M.Phil",
  "PhD",
  "Diploma",
  "Certification",
  "Other",
];

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BButton,
  BMediaAside,
  BImg,
  BMedia,
  BLink,
  BSpinner,
  BBadge,
  BFormFile,
  BFormTextarea,
  BTable,
} from "bootstrap-vue";
import { resolve } from "path";
import { reject } from "q";
export default {
  components: {
    vueDropzone: vue2Dropzone,
    // DropZone,
    BFormTextarea,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    flatPickr,
    BCard,
    BButton,
    BMediaAside,
    BImg,
    BMedia,
    BLink,
    BSpinner,
    BBadge,
    BFormFile,
    BTable,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      file: [],
      documents: [],
      uploading: false,
      request: false,
      plus: "",
      logoloading: false,
      netAmount: 0,
      dataloading: false,
      admittedSections: [],
      currentSections: [],
      classes: [],
      genders: ["Male", "Female"],
      availibility: [
        "Part Time",
        "Full Time",
        "Probation",
        "Permanent",
        "Contractual",
        "Visiting",
        "Intern",
      ],
      iussAvailabilityOptions: [
        "Immediately",
        "Within a few days",
        "Within 1 week",
        "Within 2 weeks",
      ],
      iussTeachingLevelOptions: [
        "Grade Pre Nursery to KG",
        "I till III",
        "IV till VI",
        "VII to VIII",
        "O-Level",
        "AKU-EB",
        "Matriculation",
      ],
      qualificationOptions: [...DEFAULT_QUALIFICATION_OPTIONS],
      qualifications: [],
      certificates: [],
      departmentLockedFromUrl: false,
      groups: ["A", "B", "O", "AB"],
      religions: ["Islam", "Christianity", "Hinduism", "Buddhists"],
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      myObj: {
        staff: {
          id: 0,
          rfID: "",
          name: "",
          father_name: "",
          designation: "",
          gender: "",
          picture: "",
          date_of_birth: null,
          address_current: "",
          address_permanent: "",
          province: "",
          city: "",
          linkedinProfile: "",
          salarySlip: "",
          cv: "",
          contact_number: "",
          emergency_contact_person: "",
          emergency_contact_relation: "",
          emergency_number: "",
          qualification: "",
          certificate: "",
          note: "",
          experience: "",
          campusID: this.$store.state.userData.cId,
          status: "applicant",
          documents: "",
          availibility: "",
          expectedSalary: 0,
          previousSalary: 0,
          departmentID: 0,
          cnic: "",
          teachingLevel: "",
          applicantStatus: "pending",
          registrationDate: new Date().toJSON(),
          appointedOn: null,
          leaves_allowed_from: null,
          basicSalary: 0,
          totalSalary: 0,
          tag: "Online",
          streamID: 0,
        },
        subjectIDs: [],
      },
      classObj: {
        class_admitted: null,
        section_admitted: null,
        subject_admitted: null,
      },
      fields: [
        { label: "Class", key: "class_admitted" },
        { label: "section", key: "section_admitted" },
        { label: "subject", key: "subject_admitted" },
      ],
      // for newTeachingList
      // fields2: [
      //   { label: "Class", key: "className" },
      //   { label: "section", key: "sectionName" },
      //   { label: "subject", key: "subjects" },
      //   "actions",
      // ],
      fields2: [
        { label: "Class", key: "cls" },
        { label: "section", key: "sec" },
        { label: "subject", key: "subjects" },
        "actions",
      ],

      classesOptions: [],
      teachingList: [],
      teachingClasses: [],
      newTeachingList: [],
      gridData: [],
      // teachingClassObj: {
      //   cID: 0,
      //   sectionName: "",
      //   subjects: 0,
      // },
      teachingClassObj: {
        tID: this.$route.params.id,
        clsID: 0,
        sections: [],
        subjects: [],
        campusID: this.$store.state.userData.cId,
      },
      showMessage: false,
      checkvalue: {},
      fphoneerror: false,
      mphoneerror: false,
      phoneerror: false,
      emerPhoneerror: false,
      sPhoneerror: false,
      fileProfile: "",
      vueTelOptions: { placeholder: "Enter contact number" },
      dropOptions: {
        disabled: false,
        showDialCodeInList: true,
        showFlags: true,
      },
      emerOpt: { placeholder: "Enter emergency contact" },
      subjects: [],
      docLoading: false,
      mediaLoaded: false,
      salarySlipLoading: false,
      cvLoading: false,
      campuses: [],
      departments: [],
      depLoading: false,
      school: {},
      token:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkZW1vQG15c2tvb2wuYXBwIiwianRpIjoiZmRjZjdhYzQtNmY1OS00Nzg0LTkyNDItZjFjNjRhOTdjODQ0IiwiZXhwIjoxOTkzNzk2MDgwLCJpc3MiOiJteXNrb29sLmFwcCIsImF1ZCI6Im15c2tvb2wuYXBwIn0._pMXprq3AJApizQQlcrVXS3-dPyGFMi0nT9OfLQKBlo",
      db: this.$route.query.db,
      cId: this.$route.query.cId,
      showError: false,
      designations: [],
      showDesignationField: false,
      streamOptions: [],
    };
  },
  //   mounted() {
  //     this.$refs.wizard.activateAll();
  //   },
  created() {
    if (!this.$route.query.db || !this.$route.query.cId) {
      this.showError = true;
    } else {
      this.LoadDep();
      this.LoadInfo(this.$route.query.cId);
      this.LoadSchool();
      this.loadDesignationSettings();
      if (this.showCampusField) {
        this.LoadCampuses();
      }
      if (this.isMyskoolIuss) {
        this.LoadQualifications();
        this.initializeIussQualificationRows();
      }
      if (!this.isMyskoolIuss) {
        this.LoadStreams();
      }
      this.myObj.staff.campusID = parseInt(this.$route.query.cId);
      this.applyDepartmentFromUrl();
      setTimeout(() => {
        this.sPhoneerror = false;
      }, 300);
    }
  },
  computed: {
    ...mapGetters({ campusID: "campusID" }),

    isMyskoolIuss() {
      if (this.$route.query.domain === "myskooliuss") return true;
      const host = window.location.hostname.toLowerCase();
      return host.includes("iuss") || host.startsWith("myskooliuss");
    },

    isMyskoolOrIuss() {
      const q = String(this.$route.query.domain || "").toLowerCase();
      if (q === "myskool" || q === "myskooliuss") return true;
      const report = String(this.$store.state.report || "").replace(/_/g, "");
      if (report === "myskool" || report === "myskooliuss") return true;
      const host = window.location.hostname.toLowerCase();
      if (host.includes("iuss") || host.startsWith("myskooliuss")) return true;
      if (host.startsWith("myskool.") || host === "myskool.app") return true;
      return false;
    },

    pakistanProvinces() {
      return [
        "Punjab",
        "Sindh",
        "Khyber Pakhtunkhwa",
        "Balochistan",
        "Islamabad Capital Territory",
        "Gilgit-Baltistan",
        "Azad Jammu & Kashmir",
      ];
    },

    showCampusField() {
      return (
        this.isMyskoolIuss || this.db == "/r6Q0RYpjkcmj801xyc19w=="
      );
    },

    imgUrl() {
      let img = require("@/assets/images/pages/error.svg");
      if (this.$store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        img = require("@/assets/images/pages/error-dark.svg");
        return img;
      }
      return img;
    },

    profilePicturePreview() {
      const src = this.plus || this.myObj.staff.picture;
      if (!src) return "";
      if (String(src).startsWith("blob:")) return src;
      return getMediaPreviewUrl(src, "Image");
    },

    designationOptions() {
      const depId = Number(this.myObj.staff && this.myObj.staff.departmentID) || 0;
      if (!depId) return [];
      return (this.designations || []).filter((item) => {
        const itemDepId = Number(item.departmentID) || 0;
        return itemDepId === depId;
      });
    },
  },
  methods: {
    ...mapActions({ getDepartment: "getDepartment" }),
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    getDocumentTypeLabel,
    getDocumentDisplayName,

    getDocPreviewUrl(url) {
      return getMediaPreviewUrl(url, "Image");
    },
    getDocOpenUrl(url) {
      return isImageUrl(url) ? getMediaPreviewUrl(url, "Image") : url;
    },
    onDocPreviewError(event, url) {
      if (!url) return;
      handleDrivePreviewError(event, url, "image");
    },
    isImageDoc(url) {
      return isImageUrl(url);
    },

    setData() {
      this.myObj.subjectIDs = [];
      this.LoadInfo(this.myObj.staff.campusID);
      if (this.isMyskoolIuss) {
        this.LoadDep(this.myObj.staff.campusID);
      }
      let obj = this.campuses.find((el) => el.id == this.myObj.staff.campusID);
      if (obj) {
        this.school.address = obj.address;
        this.school.phone = obj.phone;
        this.school.mobile = obj.mobile;
      }
    },
    parseDepartmentFromQuery(dpt) {
      if (dpt == null || dpt === "") return null;
      const str = decodeURIComponent(String(dpt));
      const obfuscated = str.match(/^\?\?(\d+)(?:%24|\$)$/);
      if (obfuscated) return parseInt(obfuscated[1], 10);
      const plain = parseInt(str, 10);
      return plain > 0 ? plain : null;
    },
    applyDepartmentFromUrl() {
      const dptId = this.parseDepartmentFromQuery(this.$route.query.dpt);
      if (!dptId) return;
      this.myObj.staff.departmentID = dptId;
      this.departmentLockedFromUrl = true;
    },
    parseQualificationsApiPayload(payload) {
      if (payload == null || payload === "") return [];
      if (typeof payload === "string") {
        return [
          ...new Set(
            payload
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
          ),
        ];
      }
      if (Array.isArray(payload)) {
        return [
          ...new Set(
            payload.map((s) => String(s).trim()).filter(Boolean)
          ),
        ];
      }
      if (typeof payload === "object") {
        if (Array.isArray(payload.items)) {
          return [
            ...new Set(
              payload.items.map((s) => String(s).trim()).filter(Boolean)
            ),
          ];
        }
        if (payload.value != null) {
          return this.parseQualificationsApiPayload(payload.value);
        }
        if (payload.data != null) {
          return this.parseQualificationsApiPayload(payload.data);
        }
        if (payload.status === "success" && payload.data != null) {
          return this.parseQualificationsApiPayload(payload.data);
        }
      }
      return [];
    },
    async LoadQualifications() {
      try {
        const url =
          this.$store.state.domain +
          "Settings/GetQualifications?db=" +
          encodeURIComponent(this.db) +
          "&cID=" +
          this.cId;
        const res = await this.get({ url, token: this.token });
        const list = this.parseQualificationsApiPayload(res);
        const presetSet = new Set(DEFAULT_QUALIFICATION_OPTIONS);
        const extras = list.filter((x) => x && !presetSet.has(x));
        extras.sort((a, b) =>
          a.localeCompare(b, undefined, { sensitivity: "base" })
        );
        this.qualificationOptions = [
          ...DEFAULT_QUALIFICATION_OPTIONS,
          ...extras,
        ];
      } catch (error) {
        console.error("Error loading qualifications:", error);
      }
    },
    deleteDocument(index) {
      this.documents.splice(index, 1);
      this.myObj.staff.documents = this.documents.join(",");
    },
    async uploadDocument() {
      let docs = this.$refs.cvDoc.files;
      if (docs.length != 0) {
        this.uploading = true;
        try {
          const uploaded = await uploadToMySkool(docs);
          getUploadedPaths(uploaded).forEach((path) => {
            this.documents.push(path);
          });
          this.myObj.staff.documents = this.documents.join(",");
        } catch (err) {
          console.log(err);
        } finally {
          this.uploading = false;
        }
      }
    },
    onProfilePreviewError(event) {
      handleDrivePreviewError(event, this.plus || this.myObj.staff.picture, "image");
    },
    deleteLogo() {
      if (this.plus && String(this.plus).startsWith("blob:")) {
        URL.revokeObjectURL(this.plus);
      }
      this.myObj.staff.picture = null;
      this.plus = "";
      this.logoloading = false;
      if (this.$refs.fileProfile) {
        this.$refs.fileProfile.value = null;
      }
    },
    async selectlogo() {
      const file = this.$refs.fileProfile.files[0];
      if (!file) return;

      this.fileProfile = file;
      this.logoloading = true;
      const localPreview = URL.createObjectURL(file);
      this.plus = localPreview;

      try {
        const uploaded = await uploadToMySkool([file]);
        const fn1 = getUploadPath(uploaded[0]);
        URL.revokeObjectURL(localPreview);
        this.plus = fn1;
        this.myObj.staff.picture = fn1;
        this.logoloading = "loaded";
      } catch (err) {
        URL.revokeObjectURL(localPreview);
        this.plus = "";
        this.myObj.staff.picture = null;
        this.logoloading = false;
        console.log(err);
      } finally {
        if (this.$refs.fileProfile) this.$refs.fileProfile.value = "";
      }
    },
    removeCV() {
      this.myObj.cv = null;
      this.mediaLoaded = false;
      this.$refs.cvDoc.files = null;
    },
    async addCV() {
      let doc = this.$refs.cvDoc.files[0];
      if (!doc) return;
      this.mediaLoaded = false;
      this.docLoading = true;
      try {
        const uploaded = await uploadToMySkool([doc]);
        this.myObj.cv = getUploadPath(uploaded[0]);
        this.mediaLoaded = true;
      } catch (err) {
        console.log(err);
      } finally {
        this.docLoading = false;
      }
    },
    async uploadSalarySlip() {
      const input = this.$refs.salarySlipInput;
      const file = input && input.files && input.files[0];
      if (!file) return;
      this.salarySlipLoading = true;
      try {
        const uploaded = await uploadToMySkool([file]);
        this.myObj.staff.salarySlip = getUploadPath(uploaded[0]) || "";
      } catch (err) {
        console.log(err);
        this.$bvToast.toast("Failed to upload salary slip.", {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.salarySlipLoading = false;
        if (input) input.value = "";
      }
    },
    removeSalarySlip() {
      this.myObj.staff.salarySlip = "";
      if (this.$refs.salarySlipInput) this.$refs.salarySlipInput.value = "";
    },
    async uploadStaffCv() {
      const input = this.$refs.cvFileInput;
      const file = input && input.files && input.files[0];
      if (!file) return;
      this.cvLoading = true;
      try {
        const uploaded = await uploadToMySkool([file]);
        this.myObj.staff.cv = getUploadPath(uploaded[0]) || "";
      } catch (err) {
        console.log(err);
        this.$bvToast.toast("Failed to upload CV.", {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      } finally {
        this.cvLoading = false;
        if (input) input.value = "";
      }
    },
    removeStaffCv() {
      this.myObj.staff.cv = "";
      if (this.$refs.cvFileInput) this.$refs.cvFileInput.value = "";
    },
    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.staff.name == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckFName() {
      var elem = this.$refs["fname"];
      if (this.myObj.staff.father_name == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    createEmptyQualification() {
      return {
        id: 0,
        degree: "",
        subject: "",
        institute: "",
        year: "",
        grade: "",
      };
    },
    createEmptyCertificate() {
      return {
        id: 0,
        name: "",
        institute: "",
        year: "",
      };
    },
    initializeIussQualificationRows() {
      if (!this.qualifications.length) {
        this.qualifications = [this.createEmptyQualification()];
      }
    },
    addQualification() {
      this.qualifications.push(this.createEmptyQualification());
    },
    removeQualification(index) {
      if (this.qualifications.length <= 1) return;
      this.qualifications.splice(index, 1);
      this.CheckQualification();
    },
    addCertificate() {
      this.certificates.push(this.createEmptyCertificate());
    },
    removeCertificate(index) {
      this.certificates.splice(index, 1);
    },
    getQualificationsForSave() {
      return this.qualifications
        .filter((q) => q.degree && String(q.degree).trim())
        .map((q) => ({
          id: q.id || 0,
          degree: String(q.degree).trim(),
          subject: String(q.subject || "").trim(),
          institute: String(q.institute || "").trim(),
          year: String(q.year || "").trim(),
          grade: String(q.grade || "").trim(),
        }));
    },
    getCertificatesForSave() {
      return this.certificates
        .filter((c) => c.name && String(c.name).trim())
        .map((c) => ({
          id: c.id || 0,
          name: String(c.name).trim(),
          institute: String(c.institute || "").trim(),
          year: String(c.year || "").trim(),
        }));
    },
    syncStaffQualificationFromList() {
      const list = this.getQualificationsForSave();
      this.myObj.staff.qualification = list.length ? list[0].degree : "";
    },
    buildApplicantSaveBody() {
      if (this.isMyskoolIuss) {
        this.syncStaffQualificationFromList();
      }
      this.myObj.staff.previousSalary =
        parseInt(this.myObj.staff.previousSalary, 10) || 0;
      this.myObj.staff.expectedSalary =
        parseInt(this.myObj.staff.expectedSalary, 10) || 0;
      const staff = {
        ...this.myObj.staff,
        streamID: streamIdForApi(this.myObj.staff.streamID),
      };
      const body = {
        staff,
        subjectIDs: this.myObj.subjectIDs,
        interviews: [],
        approvals: [],
      };
      if (this.isMyskoolIuss) {
        body.qualifications = this.getQualificationsForSave();
        body.certificates = this.getCertificatesForSave();
      }
      return body;
    },
    resetIussQualificationRows() {
      this.qualifications = [this.createEmptyQualification()];
      this.certificates = [];
    },
    CheckQualification() {
      if (this.isMyskoolIuss) {
        const ref = this.$refs.qua;
        const elem = Array.isArray(ref) ? ref[0] : ref;
        const valid = this.qualifications.some(
          (q) => q.degree && String(q.degree).trim()
        );
        if (elem) {
          elem.state = valid;
        }
        return valid;
      }
      var elem = this.$refs["qua"];
      if (this.myObj.staff.qualification == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDesignation() {
      var elem = this.$refs["design"];
      if (this.myObj.staff.designation == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckFContact() {
      // console.log(this.myObj.contact_father);
      // console.log(this.myObj.contact_father.length);
      if (this.myObj.contact_father.length == 12) {
        this.fphoneerror = false;
        return true;
      } else {
        this.fphoneerror = true;
        return false;
      }
    },
    CheckMContact() {
      // console.log(this.myObj.contact_mother);
      // console.log(this.myObj.contact_mother.length);
      if (this.myObj.contact_mother.length == 12) {
        this.mphoneerror = false;
        return true;
      } else {
        this.mphoneerror = true;
        return false;
      }
    },
    CheckSContact(s, e) {
      // console.log(this.myObj.contact_number);
      // console.log(this.myObj.contact_student.length);
      // if (this.myObj.staff.contact_number.length == 12) {
      //   this.sPhoneerror = false;
      //   return true;
      // } else {
      //   this.sPhoneerror = true;
      //   return false;
      // }
      if (e.valid) {
        this.sPhoneerror = false;
        this.myObj.staff.contact_number = e.number;
      } else {
        this.sPhoneerror = true;
      }
    },

    CheckEmerName() {
      var elem = this.$refs["emerName"];
      if (
        this.myObj.staff.emergency_name == null ||
        this.myObj.staff.emergency_name == ""
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmerRelation() {
      var elem = this.$refs["emerRel"];
      if (
        this.myObj.staff.emergency_relationship == null ||
        this.myObj.staff.emergency_relationship == ""
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckEmerContact() {
      if (this.myObj.staff.emergency_contact.length == 12) {
        // console.log(this.myObj.staff.emergency_contact.length);
        this.emerPhoneerror = false;
        return true;
      } else {
        this.emerPhoneerror = true;
        return false;
      }
    },
    CheckSalary() {
      const regex = /^(\d*([.,](?=\d{3}))?\d+)+((?!\2)[.,]\d\d)?$/;
      var elem = this.$refs["salary"];
      if (regex.test(this.myObj.staff.expectedSalary)) {
        if (this.myObj.staff.expectedSalary == 0) {
          return (elem.state = false);
        } else {
          this.myObj.staff.expectedSalary = parseInt(
            this.myObj.staff.expectedSalary
          );
          return (elem.state = true);
        }
      } else {
        return (elem.state = false);
      }
    },
    CheckPreviousSalary() {
      if (!this.isMyskoolIuss) return true;
      var elem = this.$refs["prevSalary"];
      const val = parseInt(this.myObj.staff.previousSalary, 10);
      if (!val || val <= 0) {
        if (elem) elem.state = false;
        return false;
      }
      this.myObj.staff.previousSalary = val;
      if (elem) elem.state = true;
      return true;
    },
    CheckAvailability() {
      if (!this.isMyskoolIuss) return true;
      var elem = this.$refs["avail"];
      if (!this.myObj.staff.availibility) {
        if (elem) elem.state = false;
        return false;
      }
      if (elem) elem.state = true;
      return true;
    },
    CheckCampus() {
      if (!this.showCampusField) return true;
      var elem = this.$refs["camp"];
      if (!this.myObj.staff.campusID) {
        if (elem) elem.state = false;
        return false;
      }
      if (elem) elem.state = true;
      return true;
    },
    CheckGrNo() {
      var elem = this.$refs["grNo"];
      if (this.myObj.grNo == null || this.myObj.grNo == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDep() {
      var elem = this.$refs["dep"];
      if (this.myObj.staff.departmentID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    onDepartmentChange() {
      if (this.myObj.staff.designation) {
        const stillValid = this.designationOptions.some(
          (d) => d.name === this.myObj.staff.designation
        );
        if (!stillValid) this.myObj.staff.designation = "";
      }
      this.CheckDep();
    },
    normalizeDesignations(rawValue) {
      const toOption = (item, index) => {
        if (typeof item === "string") {
          return {
            id: index + 1,
            name: item.trim(),
            departmentID: 0,
          };
        }
        return {
          id: index + 1,
          name: String(item.name || "").trim(),
          departmentID: Number(item.departmentID) || 0,
        };
      };

      if (!rawValue) return [];

      if (typeof rawValue === "string" && rawValue.trim().startsWith("[")) {
        try {
          const parsed = JSON.parse(rawValue);
          if (Array.isArray(parsed)) {
            return parsed
              .map((item, index) => toOption(item, index))
              .filter((item) => item.name);
          }
        } catch (e) {
          // fall through
        }
      }

      if (typeof rawValue === "string") {
        return rawValue
          .split(",")
          .map((name) => name.trim())
          .filter((name) => name)
          .map((name, index) => ({
            id: index + 1,
            name,
            departmentID: 0,
          }));
      }

      if (Array.isArray(rawValue)) {
        return rawValue
          .map((item, index) => toOption(item, index))
          .filter((item) => item.name);
      }

      return [];
    },
    CheckCnic() {
      var elem = this.$refs["cnic"];
      if (!this.myObj.staff.cnic) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDate() {
      var elem = this.$refs["dob"];
      if (!this.myObj.staff.date_of_birth) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckGender() {
      var elem = this.$refs["gender"];
      if (this.myObj.staff.gender == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckAddress() {
      var elem = this.$refs["address"];
      if (this.myObj.staff.address_current == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckTcID() {
      var elem = this.$refs["tcID"];
      if (this.teachingClassObj.clsID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckTSection() {
      // console.log(this.teachingClassObj.sections.length);
      var elem = this.$refs["tSection"];
      if (this.teachingClassObj.sections.length === 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckTSubject() {
      // console.log(this.teachingClassObj.subjects.length);
      var elem = this.$refs["sub"];
      if (this.myObj.subjectIDs.length === 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    FillSections() {
      console.log(this.teachingClassObj.clsID);
      // this.teachingClassObj.sections = [];
      this.classes.forEach((elem) => {
        if (elem.cls.id === this.teachingClassObj.clsID) {
          if (elem.sections.length != 0) {
            console.log("not null");
            this.admittedSections = elem.sections;
          } else {
            console.log("null");
            this.admittedSections = [];
          }
        }
      });
      console.log("Thisis", this.admittedSections);
    },
    async assign() {
      this.teachingClassObj.tID = parseInt(this.$route.params.id);
      console.log(this.teachingClassObj);
      this.CheckTcID();
      this.CheckTSubject();
      this.CheckTSection();
      if (
        this.CheckTcID() == false ||
        this.CheckTSubject() == false ||
        this.CheckTSection() == false
      ) {
        return this.$bvToast.toast("Please enter all the required fields.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-right",
        });
      } else {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "TeacherClasses/SaveData?db=" +
            this.$store.state.userData.db,
          body: this.teachingClassObj,
          message: "Classes assigned successfully.",
          context: this,
          token: this.token,
        });
        if (status) {
          this.LoadTeachingClasses();
          this.teachingClassObj = {
            tID: this.$route.params.id,
            clsID: 0,
            sections: [],
            subjects: [],
            campusID: this.$store.state.userData.cId,
          };
        }
      }
    },
    FillSectionsCurrent() {
      //return console.log(this.classes);
      this.classes.forEach((elem) => {
        if (elem.id == this.myObj.class_current) {
          this.currentSections = elem.sections.split(",");
        }
      });
      console.log("Thisis", this.admittedSections);
    },
    async loadDesignationSettings() {
      try {
        const response = await this.post({
          url: `${this.$store.state.domain}Settings/getSettingsAll?db=${this.db}&cId=${this.cId}`,
          body: ["staff-designations"],
          context: this,
          token: this.token,
          subjects: true,
        });

        let settingsArray = [];
        if (
          response &&
          response.status === "success" &&
          Array.isArray(response.data)
        ) {
          settingsArray = response.data;
        } else if (response && Array.isArray(response.data)) {
          settingsArray = response.data;
        } else if (Array.isArray(response)) {
          settingsArray = response;
        }

        const setting = settingsArray.find(
          (s) => s.key === "staff-designations"
        );
        if (setting && setting.value) {
          this.designations = this.normalizeDesignations(setting.value);
          this.showDesignationField = this.designations.length > 0;
        } else {
          this.designations = [];
          this.showDesignationField = false;
        }
      } catch (error) {
        console.error("Error loading designation settings:", error);
        this.designations = [];
        this.showDesignationField = false;
      }
    },
    async LoadData(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "staff/LoadSelectedApplicant?db=" +
          this.$store.state.userData.db +
          "&id=" +
          id,
        token: this.token,
      };
      this.myObj = await this.get(obj);
      // streamID 0 / missing => All Streams (sentinel option id)
      this.normalizeStaffStreamID();
      console.log(this.myObj);
      if (
        this.myObj.staff.picture !== null &&
        this.myObj.staff.picture !== ""
      ) {
        this.plus = this.myObj.staff.picture;
        this.logoloading = "loaded";
      }
      if (
        this.myObj.staff.documents !== null &&
        this.myObj.staff.documents !== ""
      ) {
        this.documents = this.myObj.staff.documents.split(",");
        // console.log(this.documents);
      }
    },
    async LoadStreams() {
      var obj = {
        url:
          this.$store.state.domain +
          "Stream/LoadSelectedData?db=" +
          this.db +
          "&cID=" +
          this.cId,
        token: this.token,
      };
      try {
        let list = await this.get(obj);
        if (!Array.isArray(list) && list && Array.isArray(list.data)) {
          list = list.data;
        }
        this.streamOptions = buildStreamOptions(list, this.$t("All Streams"));
      } catch (error) {
        console.error("Error loading stream selected data:", error);
        this.streamOptions = buildStreamOptions([], this.$t("All Streams"));
      }
      // Re-apply after options load so the sentinel option binds correctly
      this.normalizeStaffStreamID();
    },
    normalizeStaffStreamID() {
      if (!this.myObj || !this.myObj.staff) return;
      this.$set(
        this.myObj.staff,
        "streamID",
        normalizeStreamIdForUi(this.myObj.staff.streamID)
      );
    },
    async LoadInfo(id) {
      this.dataloading = true;

      var obj = {
        url:
          this.$store.state.domain +
          "Subjects?db=" +
          (this.db || this.$store.state.userData.db) +
          "&cId=" +
          id,
        token: this.token,
      };
      this.subjects = await this.get(obj);

      // console.log("subject", this.subjects);
      this.dataloading = false;
    },
    async LoadSchool() {
      var obj = {
        url:
          this.$store.state.domain +
          "Campuses/GetSelected?id=" +
          (this.cId || this.$store.state.userData.cId) +
          "&db=" +
          (this.db || this.$store.state.userData.db),
        token: this.token,
      };
      let res = await this.get(obj);
      if (res == "NotFound" || Array.isArray(res)) this.showError = true;
      else this.school = res;
      // console.log("sch:", this.school);
    },
    async LoadDep(campusId) {
      this.depLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "StaffDepartments?db=" +
          (this.db || this.$store.state.userData.db) +
          "&cId=" +
          (campusId || this.myObj.staff.campusID || this.cId || this.$store.state.userData.cId),
        token: this.token,
      };
      this.departments = await this.get(obj);
      this.depLoading = false;
      if (this.departmentLockedFromUrl) {
        this.applyDepartmentFromUrl();
      }
    },
    async LoadCampuses() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.db +
          "&cId=" +
          this.cId,
        token: this.token,
      };
      this.campuses = await this.get(obj);
    },
    EditTeaching(item) {
      console.log(item);
      this.teachingClassObj = {
        tID: this.$route.params.id,
        clsID: 0,
        sections: [],
        subjects: [],
        campusID: this.$store.state.userData.cId,
      };
      this.teachingClassObj.clsID = item.clsID;
      item.subjects.forEach((el) => this.teachingClassObj.subjects.push(el.id));
      this.FillSections();
      this.teachingClassObj.sections = item.sections;
    },
    async DeleteTeaching(item) {
      console.log(item);
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "TeacherClasses/Remove?db=" +
            this.$store.state.userData.db,
          body: item,
          message: "Teaching classes removed successfully.",
          context: this,
          token: this.token,
        });
        console.log(status);
        if (status) this.LoadTeachingClasses();
      }
    },
    cleanStates() {
      var elem = this.$refs["name"];
      elem.state = undefined;
      var elem = this.$refs["fname"];
      elem.state = undefined;
      var elem = this.$refs["design"];
      elem.state = undefined;
      var elem = this.$refs["qua"];
      elem.state = undefined;
      var elem = this.$refs["salary"];
      elem.state = undefined;
      var elem = this.$refs["dep"];
      elem.state = undefined;
      var elem = this.$refs["cnic"];
      elem.state = undefined;
      var elem = this.$refs["dob"];
      elem.state = undefined;
      var elem = this.$refs["gender"];
      elem.state = undefined;
      var elem = this.$refs["address"];
      elem.state = undefined;
    },
    async formSubmitted() {
      this.CheckName();
      this.CheckFName();
      this.CheckDesignation();
      this.CheckQualification();
      this.CheckSalary();
      this.CheckDep();
      this.CheckCnic();
      this.CheckDate();
      this.CheckGender();
      this.CheckAddress();
      if (this.isMyskoolIuss) {
        this.CheckCampus();
        this.CheckPreviousSalary();
        this.CheckAvailability();
      }
      if (this.myObj.staff.contact_number == "") this.sPhoneerror = true;

      const iussInvalid =
        this.isMyskoolIuss &&
        (this.CheckCampus() == false ||
          this.CheckPreviousSalary() == false ||
          this.CheckAvailability() == false);

      if (
        this.CheckName() == false ||
        this.CheckFName() == false ||
        this.myObj.staff.contact_number == "" ||
        this.sPhoneerror ||
        this.CheckDesignation() == false ||
        this.CheckQualification() == false ||
        this.CheckSalary() == false ||
        this.CheckDep() == false ||
        this.CheckCnic() == false ||
        this.CheckDate() == false ||
        this.CheckGender() == false ||
        this.CheckAddress() == false ||
        iussInvalid
      ) {
        return this.$bvToast.toast("Please fill the form correctly!", {
          title: this.$t("Error!"),
          variant: "danger",
          solid: true,
        });
      } else {
        if (this.myObj.staff.date_of_birth == "") {
          this.myObj.staff.date_of_birth = null;
        }

        this.myObj.staff.tag = "Online";

        // console.log("obj", this.myObj);
        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "staff/SaveApplicantNew?db=" +
            this.db +
            "&userID=" +
            (this.$store.state.userData && this.$store.state.userData.userID
              ? this.$store.state.userData.userID
              : 0),
          body: this.buildApplicantSaveBody(),
          registration: true,
          context: this,
          token: this.token,
        });
        this.request = false;
        if (status) {
          Swal.fire({
            title: "Thank you for submitting the form!",
            text: "We appreciate your interest and will get back to you as soon as possible.",
            icon: "success",
            // confirmButtonColor: "#3085d6",
            // confirmButtonText: "ok",
          });
          this.myObj = {
            staff: {
              id: 0,
              rfID: "",
              name: "",
              father_name: "",
              designation: "",
              gender: "",
              picture: "",
              date_of_birth: null,
              address_current: "",
              address_permanent: "",
              province: "",
              city: "",
              linkedinProfile: "",
              salarySlip: "",
              cv: "",
              contact_number: "",
              emergency_contact_person: "",
              emergency_contact_relation: "",
              emergency_number: "",
              qualification: "",
              certificate: "",
              note: "",
              experience: "",
              campusID: this.myObj.staff.campusID,
              status: "applicant",
              documents: "",
              availibility: "",
              expectedSalary: 0,
              previousSalary: 0,
              departmentID: this.departmentLockedFromUrl
                ? this.myObj.staff.departmentID
                : 0,
              cnic: "",
              teachingLevel: "",
              applicantStatus: "pending",
              registrationDate: new Date().toJSON(),
              appointedOn: null,
              leaves_allowed_from: null,
              basicSalary: 0,
              totalSalary: 0,
            },
            subjectIDs: [],
          };
          this.normalizeStaffStreamID();
          if (this.isMyskoolIuss) {
            this.resetIussQualificationRows();
          }
          this.cleanStates();
          this.deleteLogo();
          this.documents = [];
          if (this.$refs.cvDoc) this.$refs.cvDoc.value = "";
          setTimeout(() => {
            this.sPhoneerror = false;
          }, 300);
        }
      }
    },
  },
};
</script>
<style>
.heading {
  padding: 0;
  margin: 2.171303074670571vw 0;
  /* text-shadow: -4px 0 5px white, 0 4px 5px white, 4px 0 5px white,
          0 -4px 5px white; */
}
.input-form {
  margin: 0 70px;
  background: #fff;
}
#fileInput .custom-file-label {
  color: #707070;
  border: 1px dashed #33312f;
  text-align: center;
  padding: 2.5rem 1.5rem;
  width: 100%;
}
#fileInput input {
  display: none;
}
#imgInput input {
  display: none;
}
#imgInput {
  /* height: 8rem; */
  width: 50%;
}
#imgInput div {
  height: 8vw;
}
#imgInput .custom-file-label {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.type {
  background-color: red;
  border-radius: 10px;
  font-size: 0.8rem;
  padding: 10px;
  color: white;
}
.filename {
  padding-left: 25px;
}
.delete {
  margin: 0 0 0 auto;
  color: red;
}
#checkbox-1 {
  margin-right: 10px !important;
}
.submit {
  background-color: #00c192;
  color: #fff;
  width: 16.5vw;
  height: 4vw;
  font-weight: bold;
  border-color: #00c192;
}
.form-file-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 20px;
}
/* #prop-det, #prop-det div {
        height: 100%;
      } */

.item-group {
  width: 50%;
  /* margin-top: 2.269399707174231vw; */
}
.inputfields,
.inputfields:focus {
  border: 1px solid #33312f;
  border-radius: 0.5856515373352855vw;
  height: 2.562225475841874vw;
  outline: none !important;
  resize: none;
}
textarea.form-control {
  height: 8vw !important;
}
@media only screen and (max-width: 990px) {
  .mob-setting {
    padding: 0 1rem !important;
    width: 100vw !important;
    margin: 0 auto !important;
  }
  .mobile-view {
    margin: 0 !important;
  }
  /* .col-form-label,
  .form-file-text,
  .custom-control-label {
    font-size: 3vw;
  } */
  .item-group {
    margin-top: 0;
  }
  .margin-top-mobile {
    margin-top: 5vw;
  }
  /* .col-form-label {
    display: none;
  } */
  .form-input-mobile-text {
    width: 92vw;
    margin: 10px auto;
    border-radius: 2.8301610541727673vw;
    height: 12.781844802342606vw;
    font-size: 5.171303074670571vw;
    background-color: #f2f2f2 !important;
    border: 1px solid #33312f;
  }
  textarea.form-control {
    height: 12.781844802342606vw !important;
  }
  .form-input-mobile-text:focus {
    background-color: #00c192 !important;
    color: #fff !important;
  }
  .form-input-mobile-text::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgb(190, 190, 190);
    opacity: 1; /* Firefox */
    font-family: DINNextRoundedLTW01-Regular;
  }

  .form-input-mobile-text:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgb(190, 190, 190);
  }

  .form-input-mobile-text::-ms-input-placeholder {
    /* Microsoft Edge */
    color: rgb(190, 190, 190);
  }

  .form-input-mobile-text:focus::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #fff;
  }
  .form-file-input-mobile {
    border-radius: 2.8301610541727673vw;
    height: 12.781844802342606vw;
    background-color: #f2f2f2 !important;
    color: #fff !important;
  }
  .custom-file-label {
    border-radius: 2.8301610541727673vw !important;
    height: 12.781844802342606vw;
    background-color: #f2f2f2 !important;
    color: #000 !important;
    height: 40vw;
    border: 1px solid #33312f;
  }
  .submit {
    width: 50vw;
    height: 10vw;
  }
  .filename {
    font-size: 3vw;
  }
  .shadowHead {
    font-size: 8vw !important;
  }
  #imgInput div {
    height: 29vw !important;
  }
  .item-group {
    height: 30vw !important;
  }
}

@media only screen and (min-width: 1366px) {
  .submit {
    width: 15.5vw;
    height: 7.8vh;
  }
}
@media only screen and (min-width: 1440px) {
  .submit {
    width: 14.7vw;
    height: 6.7vh;
  }
}
@media only screen and (min-width: 1536px) {
  .submit {
    width: 13.8vw;
    height: 6.9vh;
  }
}
@media only screen and (min-width: 1920px) {
  .submit {
    width: 11vw;
    height: 5.5vh;
  }
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
</style>
<style scoped>
.file-uploader {
  position: relative;
  border: 1px solid #000;
  width: 100%;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
  font-family: "Helvetica", sans-serif;
  height: 50px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.file_upload {
  opacity: 0;

  /* IE 8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";

  /* IE 5-7 */
  filter: alpha(opacity=0);

  /* Netscape or and older firefox browsers */
  -moz-opacity: 0;

  /* older Safari browsers */
  -khtml-opacity: 0;

  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.file {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.file-type {
  background-color: #e62e2d;
  font-family: "Helvetica", sans-serif;
  color: white;
  border-radius: 10px;
  margin-right: 15px;
  height: 50px;
  width: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  overflow: hidden;
  font-size: 0.75rem;
  line-height: 1.1;
}

.file-name {
  font-family: "Helvetica", sans-serif;
  margin: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
}

.file-delete i {
  color: #e62e2d;
  font-size: 2rem;
  cursor: pointer;
}
.staff-photo-aside {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
}

.staff-photo-upload {
  display: flex;
  justify-content: center;
  width: 100%;
}

.staff-photo-frame {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.staff-photo-frame--loaded {
  position: relative;
}

.staff-photo-upload-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 100px;
  z-index: 3;
}

.staff-photo-img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  cursor: pointer;
}

.staff-photo-delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.25rem 0.4rem;
}

.doc-list-thumb {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
  margin-right: 10px;
  flex-shrink: 0;
}

.rcorners2 {
  border-radius: 100px;
  border: 4px solid var(--primary);
  padding: 2px;
}
.sticky {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-right: 60px;
  margin-bottom: 30px;
  /* position: fixed;
          bottom: 5%;
          z-index: 1031;  */
}
</style>
<style lang="scss">
@import "~@core/scss/base/bootstrap-extended/include";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.iuss-entry-section {
  .iuss-entry-head {
    border-bottom: 1px solid #ebe9f1;
    padding-bottom: 0.5rem;
  }

  .iuss-entry-row {
    padding: 0.65rem 0;
    border-bottom: 1px solid #f3f2f7;
  }

  .iuss-entry-row:last-child {
    border-bottom: none;
  }

  .iuss-entry-row-inner {
    align-items: flex-end;

    > [class*="col"] {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
  }

  .iuss-entry-field {
    width: 100%;
    margin-bottom: 0 !important;
  }

  .iuss-entry-select-wrap {
    width: 100%;

    .v-select {
      margin: 0;
    }

    .vs__dropdown-toggle {
      box-sizing: border-box !important;
      height: $input-height !important;
      min-height: $input-height !important;
      max-height: $input-height !important;
      padding: 0 $input-padding-x !important;
      border: $input-border-width solid $input-border-color !important;
      border-radius: $input-border-radius !important;
      background: $input-bg !important;
      display: flex;
      align-items: center;
      box-shadow: none !important;
    }

    .vs__selected-options {
      min-height: 0;
      padding: 0;
      margin: 0;
      flex-wrap: nowrap;
      align-items: center;
    }

    .vs__selected {
      margin: 0 !important;
      padding: 0 !important;
      line-height: $line-height-base;
      font-size: $font-size-base;
      color: $input-color;
    }

    .vs__search {
      margin: 0;
      padding: 0;
      line-height: $line-height-base;
      font-size: $font-size-base;
    }

    .vs__actions {
      padding: 0 0 0 4px;
      align-items: center;
    }

    .vs__open-indicator {
      margin-top: 0;
      transform: scale(0.9);
    }
  }

  .iuss-entry-row .form-control {
    height: $input-height;
    padding: $input-padding-y $input-padding-x;
    line-height: $line-height-base;
    font-size: $font-size-base;
  }

  .iuss-entry-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: $input-height;
    padding-bottom: 0;
  }

  .iuss-entry-add-btn,
  .iuss-entry-remove-btn {
    width: $input-height;
    height: $input-height;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  @include media-breakpoint-down(md) {
    .iuss-entry-row {
      background: #fafafa;
      border: 1px solid #f0eff5;
      border-radius: 0.5rem;
      padding: 0.85rem 0.5rem;
      margin-bottom: 0.75rem;
      border-bottom: none;
    }

    .iuss-entry-row:last-child {
      margin-bottom: 0;
    }

    .iuss-entry-row-inner {
      align-items: stretch;

      > [class*="col-12"] {
        margin-bottom: 0.75rem;
      }

      > [class*="col-12"]:last-child {
        margin-bottom: 0;
      }
    }

    .iuss-entry-field {
      legend,
      label {
        margin-bottom: 0.35rem;
      }
    }

    .iuss-entry-actions {
      min-height: $input-height;
      justify-content: flex-end;
      align-items: flex-end;
      padding-bottom: 0;
      margin-bottom: 0 !important;
    }

    .iuss-entry-remove-btn {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
}
</style>
